import { createBreakpoints } from "@chakra-ui/theme-tools";
export const breakpoints = createBreakpoints({
  sm: "400px",
  md: "768px",
  lg: "960px",
  xl: "1200px",
  "2xl": "1200px",
});
